import Swal from "sweetalert2";
class AlertService2 {
    static modal(msg, title, customOptions) {
        const options = {
            title: title,
            html: msg,
            imageWidth: 60,
            imageHeight: 60,
            showCloseButton: true,
            showConfirmButton: false,
            backdrop: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            customClass: {
                confirmButton: "btn btn-primary",
                cancelButton: "btn btn-default",
                denyButton: "btn btn-danger",
            },
            buttonsStyling: false,
            ...customOptions,
        };
        return Swal.fire(options);
    }
    static show(msg, title = "Atenção", icon = null, extraOptions = {}) {
        const defaultOptions = {
            title: title,
            html: msg,
            imageWidth: 60,
            imageHeight: 60,
            showConfirmButton: true,
            backdrop: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            icon: icon,
            customClass: {
                confirmButton: "btn btn-primary",
                cancelButton: "btn btn-danger",
            },
            buttonsStyling: false,
        };
        const options = { ...defaultOptions, ...extraOptions };
        return Swal.fire(options);
    }
    static async confirm(msg, title = "Atenção", icon = "warning", confirmButtonText = "Sim", denyButtonText = "Não", htmlContainerClass = "", extraOptions = {}) {
        const defaultOptions = {
            title: title,
            html: msg,
            imageWidth: 60,
            imageHeight: 60,
            showConfirmButton: true,
            showDenyButton: true,
            backdrop: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            icon: icon,
            customClass: {
                confirmButton: "btn btn-primary",
                cancelButton: "btn btn-default",
                denyButton: "btn btn-danger",
                htmlContainer: htmlContainerClass,
            },
            buttonsStyling: false,
            confirmButtonText: confirmButtonText,
            denyButtonText: denyButtonText,
        };
        const options = { ...defaultOptions, ...extraOptions };
        const res = await Swal.fire(options);
        return res.isConfirmed;
    }
    static error(msg, title = "", extraOptions = {}) {
        return this.show(msg, title, "error", extraOptions);
    }
    static success(msg, title = "", extraOptions = {}) {
        return this.show(msg, title, "success", extraOptions);
    }
}
export default AlertService2;
